import React from "react";

import { AppContext } from '../util';

class Onboarding extends React.Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);
        
        this.state = {
            index: 1,
            isFadeOut: false
        };
    }

    /*componentDidMount() {
        const d = this;
        window.setTimeout(() => {
            d.setState({index: 1});
        }, 1000);
    }*/

    handleClick = (e) => {
        if(this.state.index === 1) {
            this.setState({index: 2});
        } else if(this.state.index === 2) {
            
            this.setState({isFadeOut: true});
        }
    }

    render() {

        const className = this.state.isFadeOut ? 'onboarding onboarding--hidden' : 'onboarding';

        return (
            <section className={className} onClick={this.handleClick} onTransitionEnd={this.props.handleIntroEnd}>
                <div className="onboarding__inner">

                    <div className="rect">
                        <div className="rect__1"></div>
                        <div className="rect__2"></div>
                        <div className="rect__3"></div>
                    </div>

                    {this.state.index === 1 &&
                        <React.Fragment>
                            <h1 className="onboarding__headline" style={{animationDelay: '1s' }}>Expressionistische Kulturdaten</h1>
                            <p className="onboarding__text" style={{animationDelay: '1.5s' }}>
                                Stöbere durch die kulturelle Sammlung<br />
                                des Franz Marc Museums in Kochel.
                            </p>
                            <p className="onboarding__text" style={{animationDelay: '2s'}}>
                                Entdecke dabei Werke von Franz Marc<br />
                                und vielen weiteren Künstler*innen.
                            </p>
                            <img className='arrow arrow--next onboarding__arrow' src='/images/icon-arrow.svg' style={{animationDelay: '2.5s'}} />
                        </React.Fragment>
                    }

                    {this.state.index === 2 &&
                        <React.Fragment>
                            <p className="onboarding__text" style={{animationDelay: '0.5s' }}>
                                <span className='onboarding__icon' style={{backgroundImage: 'url(/images/icon-scroll.svg)'}}></span><br />
                                <strong>Scrolle</strong> hoch und runter, um<br />dich vor und zurück zu bewegen.
                            </p>
                            <p className="onboarding__text" style={{animationDelay: '1s' }}>
                                <span className='onboarding__icon' style={{backgroundImage: 'url(/images/icon-drag-drop.svg)'}}></span><br />
                                <strong>Klicke</strong> und <strong>ziehe</strong> den Hintergrund,<br />um dich umzusehen.
                            </p>
                            <img className='arrow arrow--next onboarding__arrow' src='/images/icon-arrow.svg' style={{animationDelay: '1.5s'}} />
                        </React.Fragment>
                    }
                </div>
            </section>
        )
    }
}

export default Onboarding;